import { GalavailRestService } from "clientwsGalavail";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { isNullOrUndefined } from "util";
import { DayPeriod } from '../models/day-period-model';
import * as i0 from "@angular/core";
import * as i1 from "clientwsGalavail";
var CruiseService = /** @class */ (function () {
    function CruiseService(galavailRestService) {
        this.galavailRestService = galavailRestService;
        this.cruisesArray = [];
    }
    CruiseService.prototype.search = function (searchRequestObject) {
        var _this = this;
        try {
            var httpHeaders = new HttpHeaders({
                "Content-Type": "application/json",
            });
            var body = this.jsonSearch(searchRequestObject);
            return this.galavailRestService
                .request("", "request_search_ecom", {
                headers: httpHeaders,
            }, body)
                .catch(function (error) {
                return _this.handleError(error);
            });
        }
        catch (error) {
            console.log("BarcoService.getAllcruises()");
            console.error(error);
            return this.handleError(error);
        }
    };
    CruiseService.prototype.jsonSearch = function (search) {
        return {
            month: search.month,
            year: search.year,
            adults: search.adults,
            children: search.children,
            category: isNullOrUndefined(search.cruiseCategory) ||
                isNullOrUndefined(search.cruiseCategory.value)
                ? 0
                : search.cruiseCategory.value,
            type: isNullOrUndefined(search.cruiseType) ||
                isNullOrUndefined(search.cruiseType.name)
                ? 0
                : search.cruiseType.name,
            length: isNullOrUndefined(search.tourLength)
                ? 0
                : search.tourLength.value,
            boat: isNullOrUndefined(search.cruise) ? 0 : search.cruise,
            order: search.order.value,
            page: search.page,
        };
    };
    CruiseService.prototype.handleError = function (error) {
        console.error("BarcoService.getCruises()-> HandleError");
        console.error(error);
        return Observable.throw(error);
    };
    CruiseService.prototype.setCruisesList = function (value) {
        this.cruisesArray = value;
    };
    CruiseService.prototype.getCruisesList = function () {
        return this.cruisesArray;
    };
    CruiseService.prototype.createIterDayWithItineraryData = function (itineraryData) {
        var AllItinerary = [];
        itineraryData.days.map(function (v) {
            var dataBundle = {};
            dataBundle.diaSemana = v.name;
            dataBundle.morningActivities = [];
            dataBundle.afternoonActivities = [];
            v.schedules.map(function (e) {
                e.activities.forEach(function (activity) {
                    if (e.type === DayPeriod.AM) {
                        dataBundle.morningActivities.push({
                            isla: activity.name,
                            period: e.type,
                            nombre: activity.description,
                            optional: activity.optional,
                        });
                    }
                    else {
                        dataBundle.afternoonActivities.push({
                            isla: activity.name,
                            period: e.type,
                            nombre: activity.description,
                            optional: activity.optional,
                        });
                    }
                });
            });
            AllItinerary.push(dataBundle);
        });
        return AllItinerary;
    };
    CruiseService.ngInjectableDef = i0.defineInjectable({ factory: function CruiseService_Factory() { return new CruiseService(i0.inject(i1.GalavailRestService)); }, token: CruiseService, providedIn: "root" });
    return CruiseService;
}());
export { CruiseService };
